import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { watch } from 'vue';
import useAlerts from './useAlerts';
import apolloClient from './useApolloClient';

const { addAlert } = useAlerts();

const GET_CONTACT_LEADS = gql`
  query ContactLeadsQuery($companyid: ID, $contactid: ID) {
    contactLeads(companyid: $companyid, contactid: $contactid) {
      LEADID
      CREATEDATE
      SOURCE
      ASSIGNEDID
      COMPLETE
      SCORE
      NAME
      JOBNAME
      COMPANYID
      CONTACTID
      contact {
        CONTACTID
        FIRSTNAME
        LASTNAME
      }
      company {
        COMPANYID
        NAME
      }
    }
  }
`;

export default function useContactLeadsQuery() {
  return function (params) {
    provideApolloClient(apolloClient);

    const { result, loading, error, refetch } = useQuery(GET_CONTACT_LEADS, params, { fetchPolicy: 'no-cache' });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching contact leads:', error.value);
        addAlert('Error fetching leads', 'high', 5);
      }
    });

    return {
      result,
      loading,
      error,
      refetch,
    };
  };
}
